export enum ContentType {
	PAGE = 'PAGE',
	FOLDER = 'FOLDER',
}
